<mat-checkbox [ngModel]="value"
              [class.has-error]="errorStateMatcher?.errors.length > 0"
              (ngModelChange)="writeValue($event)"
              (blur)="onBlurAction()"
              [disabled]="disabled">
    <ng-content></ng-content>
</mat-checkbox>

<app-errors *ngIf="errorStateMatcher" [errorStateMatcher]="errorStateMatcher"></app-errors>
